import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Run either `}<inlineCode parentName="p">{`npm`}</inlineCode>{` or `}<inlineCode parentName="p">{`yarn`}</inlineCode>{` in terminal to add it to your project:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install posthog-node --save
# or
yarn add posthog-node
`}</code></pre>
    <p>{`In your app, set your project API key `}<strong parentName="p">{`before`}</strong>{` making any calls.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-node"
      }}>{`import { PostHog } from 'posthog-node'

const client = new PostHog(
    '<ph_project_api_key>',
    { host: '<ph_instance_address>' } // TIP: You can omit this line if using PostHog Cloud
)

await client.shutdown() // TIP: On program exit, call shutdown to stop pending pollers and flush any remaining events
`}</code></pre>
    <p>{`You can find your project API key and instance address in the `}<a parentName="p" {...{
        "href": "https://app.posthog.com/project/settings"
      }}>{`project settings`}</a>{` page in PostHog.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` As a rule of thumb, we do not recommend hardcoding API keys. Setting it as an environment variable is preferred.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      